<template>
	<div>
		<c-dialog ref="selector" title="选择收款账号" height="70vh" enable-flex @resolve="resolveHandle">
			<div class="selector-search-bar flex-center">
				<div class="selector-search flex-center flex-grow">
					<i class="selector-search-icon c-icon-search"></i>
					<input v-model="keyword" class="flex-grow" @input="updateList">
				</div>
				<c-link class="create" icon="tf-add" @click="editHandle()">新建</c-link>
			</div>

			<c-scroll ref="scroll" class="flex-grow">
				<c-empty v-if="dataList && !dataList.length"></c-empty>
				<div v-for="(item, i) in dataList" :key="i" :ref="i" class="item flex" @click="current = item">
					<div class="check flex-center" :class="{'z-crt': current && current.id == item.id}"><i class="c-icon-check"></i></div>
					<div class="flex-grow">
						<p class="ellipsis">{{item.account_name}} | {{item.card_no}}</p>
						<p class="ellipsis"><span>{{item.bank_name}}</span></p>
					</div>
					<div class="flex-center">
						<a @click.stop="editHandle(item)"><i class="tf-edit"></i></a>
						<a @click.stop="deleteHandle(item)" style="color: #f55;"><i class="tf-trash"></i></a>
					</div>
				</div>
			</c-scroll>
		</c-dialog>

		<c-dialog ref="editor">
			<c-form ref="editForm">
				<c-form-item label="收款人" required>
					<c-input type="hidden" name="id"></c-input>
					<c-input name="account_name"></c-input>
				</c-form-item>
				<c-form-item label="开卡行及支行" required>
					<c-input name="bank_name"></c-input>
				</c-form-item>
				<c-form-item label="银行卡号" required>
					<c-input name="card_no"></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
	</div>
</template>

<script>
	import {debounce} from '@deanwu/vue-component-library-mobile'

	export default {
		name: 'accountSelector',

		data() {
			return {
				keyword: '',
				dataList: null,
				current: null
			}
		},

		methods: {
			open(data = {}) {
				this.$refs.selector.open();
				this.keyword = '';
				this.dataList = null;
				this.current = null;
				this.updateList();
			},

			updateList: debounce(function() {
				this.dataList = null;
				this.request({
					url: '/sys_user/bank_account/list',
					data: {
						keyword: this.keyword.trim()
					},
					success: data => {
						this.dataList = data;
					}
				})
			}, 200),

			editHandle(item) {
				this.$refs.editForm.clear();
				this.$refs.editForm.set(item);
				this.$refs.editor.open({
					title: item ? '编辑收款账号' : '新建收款账号',
					resolve: (stop, next) => {
						stop();
						this.$refs.editForm.submit({
							url: item ? '/sys_user/bank_account/edit' : '/sys_user/bank_account/add',
							rule: {
								account_name: '请填写收款人',
								bank_name: '请填写开卡行及支行',
								card_no: '请填写银行卡号'
							},
							success: () => {
								next();
								this.$message({
									message: '保存成功'
								});
								!item && (this.keyword = '');
								this.updateList();
							}
						})
					}
				});
			},

			deleteHandle(item) {
				this.$confirm({
					message: '确定要删除该账号吗',
					resolve: () => {
						this.request({
							url: '/sys_user/bank_account/delete',
							data: {
								id: item.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功',
									mask: true
								});
								this.updateList();
							}
						});
					}
				});
			},

			resolveHandle() {
				if (!this.current) {
					this.$message({
						message: '未选择收款账号'
					});
					return;
				}

				this.$refs.selector.close();
				this.$emit('resolve', this.current);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.create {
		margin-left: .3rem;
		line-height: .7rem;
		font-size: .3rem;
		color: #fff !important;
	}

	.item {
		gap: .26rem;
		border-bottom: .01rem solid #eee;
		padding: .26rem .08rem;
		margin: 0 .24rem;

		.check {
			box-sizing: border-box;
			width: .4rem;
			height: .4rem;
			border: .04rem solid #ccc;
			border-radius: .08rem;
			font-size: .22rem;
			color: #fff;
			box-shadow: 3px 3px 8px 0 rgba(0,0,0,.1);

			&.z-crt {
				border-color: var(--color-main);
				background: var(--color-main);
			}
		}

		p {
			line-height: .4rem;
			font-size: .32rem;

			&:nth-child(n+2) {
				margin-top: .1rem;
			}

			span {
				font-size: .26rem;
				color: #91A1B9;
			}
		}

		a {
			padding: .18rem .12rem;
			font-size: .32rem;
			color: var(--color-main);

			&:nth-child(n+2) {
				margin-left: .1rem;
			}
		}
	}
</style>
